<template>
    <div>
        <!-- 查看文件 详情 -->
        <el-dialog title="查看详情" custom-class="dialog-custom" :visible.sync="viewVoucherDialogVisible" width="1250px" :close-on-click-modal="false">
            <div class="custom-dialog" style="display: flex;">
                <div style="width: 75%;">
                    <el-card class="box-card" style="height:95%;">
                        <el-row style="margin-bottom: 10px;margin-top: -8px;padding-right: 10px;">
                            <el-col :span="8" style="line-height: 30px;">
                                <el-button plain disabled><i class="el-icon-arrow-left" style="font-size: 11px;font-weight: bold;"></i>前一凭证</el-button>
                                <el-button plain style="margin-left: 15px;" disabled>后一凭证<i class="el-icon-arrow-right" style="font-size: 11px;font-weight: bold;"></i></el-button>
                            </el-col>
                            <el-col :span="8" style="text-align: center;">
                                <el-link :underline="false"><i class="el-icon-zoom-in" style="font-size: 24px;font-weight: bold;margin-right: 30px;line-height: 32px;" @click="forchangwidth('big')"></i></el-link>
                                <el-link :underline="false"><i class="el-icon-zoom-out" style="font-size: 24px;font-weight: bold;line-height: 32px;" @click="forchangwidth('small')"></i></el-link>
                            </el-col>
                            <el-col :span="8" style="text-align: right;">
                                <!-- <el-button type="primary" style="width: 80px;" @click="downloadVoucherFileClickFun()" v-if="this.voucher.vftype == '1'">下载</el-button> -->
                                <el-button type="primary" style="width: 80px;" v-if="this.voucher.vftype == '2'"> <!-- 原始凭证下载 -->
                                    <el-link :href="downloadVoucherFileUrl + this.voucher.vid + token" :underline="false" style="color: #fff;">下载</el-link>
                                </el-button>
                                 <el-button type="primary" style="width: 80px;" v-if="this.voucher.vftype == '2'"> 
                                    <el-link :href="downloadTempFileUrl + this.voucher.vid + token" :underline="false" style="color: #fff;">下载附件</el-link>
                                </el-button>
                                <!-- <el-button plain style="margin-left: 15px;" @click="batchDownloadVoucherFileClickFun()">批量下载</el-button> -->
                            </el-col>
                        </el-row>
                        <div style="text-align: center;">
                            <div v-if="voucher.vftype && voucher.vftype == '1'">
                                <!-- <accvoucher ref="accvoucher" v-bind:accvoucherId="voucher.vid" style="width: 98%;"></accvoucher> -->
                                <accvoucher ref="accvoucher" style="width: 98%;"></accvoucher>
                            </div>
                            <div v-if="voucher.vftype && voucher.vftype == '2'" style="height: 550px;overflow-y: auto;">
                                <div id ="otherTypeText" style="font-size: 20px;color:red;display:none">该文件类型暂不支持预览，请下载查看</div>
								<img id="orivoucherImg" src="" :width="imagewidth+'%'">
                                <iframe src="" id="oriv_pdf_frame" width="98%" height="95%" frameborder="no" scrolling="yes" style="overflow-y:scroll;display:none;"></iframe>
                            </div>
                        </div>
                    </el-card>
                </div>
                <div style="width: 25%;">
                    <el-card class="box-card" style="height:95%;margin-left:5px;overflow-y: auto;">
                        <el-form :model="voucherUploadInfoForm">
                            <div>
                                <span class="voucher-tag-title">组内列表</span>
                                <div class="block" style="padding-top: 10px;padding-left: 5px;">
                                    <el-timeline>
                                        <el-timeline-item
                                            v-for="(recordObj, index) in voucherUploadInfoForm.opRecordList"
                                            :key="index"
                                            :icon="recordObj.icon"
                                            :type="recordObj.type"
                                            :color="recordObj.color"
                                            size="large"
                                            :hide-timestamp="true">
                                            <div style="display: flex;line-height: 20px;">
                                                <div v-for="(typeObj, index) in formatFileStatusImgList" :key="index">
                                                    <span v-if="typeObj.code == recordObj.opType">{{typeObj.title}}</span>
                                                </div>
                                                <span style="padding-left: 8px;">{{recordObj.opTime}}</span>
                                                <span style="padding-left: 8px;">{{recordObj.operator}}</span>
                                            </div>
                                            <el-link v-if="recordObj.groupNo" :underline="false" type="primary" style="line-height: 30px;" @click="viewGroupDetailsClickFun(recordObj.id)"> 组号：{{ recordObj.groupNo }}</el-link>
                                            <el-link v-if="recordObj.bookNo" :underline="false"  type="primary" style="line-height: 30px;" @click="viewVolumeDetailsClickFun(recordObj.id)">册号：{{ recordObj.bookNo }}</el-link>
                                        </el-timeline-item>
                                    </el-timeline>
                                </div>
                            </div>
                            <div style="padding: 5px 0px;">
                                <span class="voucher-tag-title">上传信息</span>
                                <el-row style="line-height: 25px;">
                                    <span class="voucher-tag-contmg">原文件名：{{voucherUploadInfoForm.fileName}}</span>
                                </el-row>
                                <el-row style="line-height: 25px;">
                                    <span class="voucher-tag-contmg">批次号：{{voucherUploadInfoForm.batchNo}}</span>
                                </el-row>
                                <el-row style="line-height: 25px;">
                                    <span class="voucher-tag-contmg">文件号：{{voucherUploadInfoForm.fileNo}}</span>
                                </el-row>
                                <el-row style="line-height: 25px;">
                                    <span class="voucher-tag-contmg">上传人：{{voucherUploadInfoForm.operator}}</span>
                                </el-row>
                                <el-row style="line-height: 25px;">
                                    <span class="voucher-tag-contmg">上传时间：{{this.timestampFormatter(voucherUploadInfoForm.importTime)}}</span>
                                </el-row>
                                <el-row style="line-height: 25px;">
                                    <span class="voucher-tag-contmg">导入方式：{{this.formatImportWay('', '', voucherUploadInfoForm.importWay, '')}}</span>
                                </el-row>
                            </div>
                        </el-form>
                    </el-card>
                </div>
            </div>
            <form id="downloadForm" :action="downloadVoucherFileUrl">
                <el-input type="hidden" name="ids" :value="this.voucher.vid"/>
            </form>

            <form id="downloadTempForm" :action="downloadTempFileUrl">
                <el-input type="hidden" name="ids" :value="this.voucher.vid"/>
            </form>
        </el-dialog>
        
        <!-- 查看分组详情 dialog-->
        <el-dialog title="查看组明细" :visible.sync="viewGroupDetailsDialogVisible" width="45%" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form :model="groupDetailForm">
                    <div style="padding-top: 5px;">
                        <span class="voucher-tag-title">分组信息</span>
                        <div style="line-height: 25px;">
                            <span class="voucher-tag-contmg">系统组号：{{groupDetailForm.groupNo}}</span>
                        </div>
                        <div style="line-height: 25px;">
                            <span class="voucher-tag-contmg">最近操作人：{{groupDetailForm.operator}}</span>
                        </div>
                        <div style="line-height: 25px;">
                            <span class="voucher-tag-contmg">最近更新时间：{{groupDetailForm.opTime}}</span>
                        </div>
                    </div>
                    <div style="padding-top: 5px;">
                        <el-table ref="groupDetailTable" :data="groupDetailForm.groupDetailTableData" border stripe class="table" height="400px">
                            <el-table-column prop="id" v-if="showColumn == false"></el-table-column>
                            <el-table-column prop="type" label="文件类型" width="100" align="center">
                                <template slot-scope="scoped">
                                    <div v-for="(imgObj, index) in commonVoucherTypeImgList" :key="index">
                                        <img v-if="imgObj.code == scoped.row.type " :src="require('../../../assets/img/' + imgObj.name + '.png')">
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="voucherNo" label="凭证号" sortable></el-table-column>
                            <el-table-column prop="amount"  label="金额" sortable :formatter="(row, column, cellValue, index) => this.formatAmountSeparator(cellValue)"></el-table-column>
                            <el-table-column prop="voucherDate"  label="凭证日期" sortable :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
                            <el-table-column prop="operate" label="操作" width="200" align="center" fixed="right">
                                <template slot-scope="scoped">
                                    <el-button size="small" type="text" @click="viewGroupVoucherDetailsClickFun(scoped.row)">查看文件</el-button>
                                    <span v-if="scoped.row.id > 0 && scoped.row.type != '0'" style="margin-left:4px">
                                        <el-link style="font-size:12px;" :href="downloadFileUrl + scoped.row.id + '&' + token" 
                                            :underline="false" type="primary"  >下载文件</el-link>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form>
            </div>
        </el-dialog>

        <!-- 查看成册详情 dialog -->
        <el-dialog title="查看册明细" :visible.sync="viewVolumeDetailsDialogVisible" width="1200px">
            <div class="custom-dialog">
                <el-form :model="volumeDetailForm">
                    <div>
                        <span class="voucher-tag-title">成册信息</span>
                        <div style="line-height: 25px;">
                            <span class="voucher-tag-contmg" style="padding-right: 20px;">册号：{{ volumeDetailForm.book.bookNo }}</span>
                            <span class="voucher-tag-contmg" style="padding-right: 20px;">操作人：{{ volumeDetailForm.book.operator }}</span>
                            <span class="voucher-tag-contmg">操作时间：{{ this.timestampFormatter(volumeDetailForm.book.updateTime) }}</span>
                        </div>
                    </div>
                    <div style="display: flex;padding-top: 10px;">
                        <div style="width: 65%;">
                            <div>
                                <span class="voucher-tag-title">封面详情</span>
                                <div class="mv-voucher-container">
                                <el-row class="mv-voucher-header">
                                    <span>会计凭证封面</span>
                                </el-row>
                                <el-row type="flex" style="padding-bottom: 15px;">
                                    <el-col :span="12" style="text-align: left;">
                                        <span>单位名称：</span>
                                        <span class="mv-voucher-content-span">{{ manualVolumeCoverFormData.companyName }}</span>
                                    </el-col>
                                    <el-col :span="12" style="text-align: right;">
                                        <span>凭证名称：</span>
                                        <span class="mv-voucher-content-span">会计凭证</span>
                                    </el-col>
                                </el-row>
                                <div class="mv-voucher-body">
                                    <el-row type="flex" class="mv-voucher-row">
                                        <el-col :span="4" class="mv-voucher-title">
                                            时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间
                                        </el-col>
                                        <el-col :span="20">
                                            <div style="text-align: center;">
                                                自
                                                <span class="mv-voucher-content-span">
                                                    <span v-if="manualVolumeCoverFormData.voucherBeginDate">{{ manualVolumeCoverFormData.voucherBeginDate.substr(0, 4) }}</span>
                                                </span>
                                                年
                                                <span class="mv-voucher-content-span">
                                                    <span v-if="manualVolumeCoverFormData.voucherBeginDate">{{ manualVolumeCoverFormData.voucherBeginDate.substr(5, 2) }}</span>
                                                </span>
                                                月
                                                <span class="mv-voucher-content-span">
                                                    <span v-if="manualVolumeCoverFormData.voucherBeginDate">{{ manualVolumeCoverFormData.voucherBeginDate.substr(8, 2) }}</span>
                                                </span>
                                                日起至
                                                <span class="mv-voucher-content-span">
                                                    <span v-if="manualVolumeCoverFormData.voucherEndDate">{{ manualVolumeCoverFormData.voucherEndDate.substr(0, 4) }}</span>
                                                </span>
                                                年
                                                <span class="mv-voucher-content-span">
                                                    <span v-if="manualVolumeCoverFormData.voucherEndDate">{{ manualVolumeCoverFormData.voucherEndDate.substr(5, 2) }}</span>
                                                </span>
                                                月
                                                <span class="mv-voucher-content-span">
                                                    <span v-if="manualVolumeCoverFormData.voucherEndDate">{{ manualVolumeCoverFormData.voucherEndDate.substr(8, 2) }}</span>
                                                </span>
                                                日止
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <el-row type="flex" class="mv-voucher-row">
                                        <el-col :span="4" class="mv-voucher-title">
                                            册&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数
                                        </el-col>
                                        <el-col :span="20">
                                            <el-row type="flex">
                                                <el-col :span="8" class="mv-voucher-content">
                                                    共
                                                    <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.bookTotal}}</span>
                                                    册
                                                </el-col>
                                                <el-col :span="6" class="mv-voucher-content">
                                                    册次
                                                </el-col>
                                                <el-col :span="10" class="mv-voucher-content" style="border-right: none;">
                                                    本册是第
                                                    <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.bookIndex}}</span>
                                                    册
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                    </el-row>
                                    <el-row type="flex" class="mv-voucher-row">
                                        <el-col :span="4" class="mv-voucher-title">
                                            记账凭证
                                        </el-col>
                                        <el-col :span="20" style="text-align: center;">
                                            本册自第
                                            <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.voucherBeginNo}}</span>
                                            号至第
                                            <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.voucherEndNo}}</span>
                                            号共
                                            <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.accVoucherTotal}}</span>
                                            张
                                        </el-col>
                                    </el-row>
                                    <el-row type="flex" class="mv-voucher-row">
                                        <el-col :span="4" class="mv-voucher-title">
                                            附&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;件
                                        </el-col>
                                        <el-col :span="20">
                                            <el-row type="flex">
                                                <el-col :span="12" class="mv-voucher-content">
                                                    共
                                                    <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.oriVoucherTotal}}</span>
                                                    册
                                                </el-col>
                                                <el-col :span="12"  class="mv-voucher-content" style="border-right: none;">
                                                    本册凭证合计
                                                    <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.attachmentTotal}}</span>
                                                    张
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                    </el-row>
                                    <el-row type="flex" style="line-height: 88px;">
                                        <el-col :span="4" class="mv-voucher-title">
                                            备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注
                                        </el-col>
                                        <el-col :span="20">
                                            <el-form-item style="padding: 10px 5px 15px 5px;">
                                                {{ manualVolumeCoverFormData.remark }}
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="mv-voucher-footer">
                                    <el-row type="flex">
                                        <el-col :span="8">
                                            会计主管
                                            <!-- <span class="mv-voucher-footer-span">{{ manualVolumeCoverFormData.treasurer }}</span> -->
                                            <span class="mv-voucher-footer-span"></span>
                                        </el-col>
                                        <el-col :span="8" style="text-align: center;">
                                            装订人
                                            <span class="mv-voucher-footer-span">{{ manualVolumeCoverFormData.bookedUser }}</span>
                                        </el-col>
                                        <el-col :span="8" style="text-align: right;">
                                            <span class="mv-voucher-footer-span">
                                                <span v-if="manualVolumeCoverFormData.bookedDate">{{ manualVolumeCoverFormData.bookedDate.substr(0, 4) }}</span>
                                            </span>
                                                年
                                                <span class="mv-voucher-footer-span">
                                                    <span v-if="manualVolumeCoverFormData.bookedDate">{{ manualVolumeCoverFormData.bookedDate.substr(5, 2) }}</span>
                                                </span>
                                                月
                                                <span class="mv-voucher-footer-span">
                                                    <span v-if="manualVolumeCoverFormData.bookedDate">{{ manualVolumeCoverFormData.bookedDate.substr(8, 2) }}</span>
                                                </span>
                                                日
                                        </el-col>
                                    </el-row>
                                </div>
                                </div>
                                <!-- <div style="box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding-top: 10px;margin-top: 5px;">
                                    <img src="../../../assets/img/voucher_demo.jpg" width="98%" height="50%" style="margin: 5px;">
                                </div> -->
                            </div>
                        </div>
                        <div style="width: 35%;padding-left: 20px;">
                            <span class="voucher-tag-title">册内详情</span>
                            <div style="padding-top: 5px;height: 85%;">
                                <el-table :data="volumeDetailForm.volumnDetailTableData" style="width: 100%;" border stripe class="table" height="100%">
                                    <el-table-column prop="id" v-if="showColumn == false"></el-table-column>
                                    <el-table-column prop="groupNo" label="系统组号" ></el-table-column>
                                    <el-table-column prop="voucherNo" label="记账凭证号" ></el-table-column>
                                    <el-table-column prop="operate" label="操作" width="120" align="center">
                                        <template slot-scope="scoped">
                                            <el-button size="small" type="text" @click="viewGroupDetailsClickFun(scoped.row.id)">查看分组</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="pagination" style="text-align: center;">
                                    <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="volumedetailpwm.page"
                                        :page-size="volumedetailpwm.limit"
                                        :page-sizes="volumedetailpwm.limits"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="volumedetailpwm.count">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import https, { fetchPost } from '../../../../https.js';
    import accvoucher from '../common/accvoucher.vue';

    export default {
        props: {
            voucher: {
                vftype: String,
                vid: String
            }
        },    //  父组件传来的值
        data() {
            return {
                showColumn: true,
                viewVoucherDialogVisible: false,    //  查看文件 dialog
                formatFileStatusImgList: JSON.parse(JSON.stringify(this.fileStatusList)),
                commonVoucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)).concat(JSON.parse(JSON.stringify(this.accountingVoucherTypeList))),
                voucherUploadInfoForm: {	// 查看详情-上传信息
                    fileName: '',
                    batchNo: '',
                    fileNo: '',
                    operator: '',
                    importTime: '',
                    importWay: '',
                    opRecordList: []
                },
                groupDetailForm: {
                    groupNo: '',
                    operator: '',
                    opTime: '',
                    groupDetailTableData: []
                },
                downloadVoucherFileUrl: this.baseURL + "/archival/voucher/downloadOriVoucherFile?ids=",
                downloadFileUrl: this.baseURL + '/dowload/dowloadOvFile?id=',
                downloadTempFileUrl: this.baseURL + "/dowload/dowloadTempFile?id=",
                token: '&token=' + localStorage.getItem('token'),
                viewGroupDetailsDialogVisible: false,
                viewVolumeDetailsDialogVisible: false,
                volumedetailpwm: JSON.parse(JSON.stringify(this.pageobj)),
                volumeDetailForm: {
                    volumnDetailTableData: [],
                    book: {}    //  册信息
                },
                manualVolumeCoverFormData: {   //  册封面数据
                    companyName: '',
                    voucherName:'',
                    voucherBeginDate:'',
                    voucherEndDate: '',
                    bookTotal: '',
                    bookIndex: '',
                    voucherBeginNo: '',
                    voucherEndNo: '',
                    oriVoucherTotal: '',
                    accVoucherTotal: '',
                    attachmentTotal:'',
                    remark: '',
                    treasurer: '',
                    bookedUser: '',
                    bookedDate: ''
                },
				imagewidth:98
            }
        },
        methods: {
            handleSizeChange(val) {
                this.volumedetailpwm.limit = val;
                this.getVolumeGroupDetailDataByBookId(this.volumeDetailForm.book.id);
            },
            handleCurrentChange(val) {
                this.volumedetailpwm.page = val;
                this.getVolumeGroupDetailDataByBookId(this.volumeDetailForm.book.id);
            },
            viewVoucherDetailsClickFun() { //  查看凭证文件
                if(this.voucher.vftype == '1') {
                    this.getAccVoucherDetailDataById(this.voucher.vid).then(accVoucherUploadData => {
                        if(accVoucherUploadData.opRecordList && accVoucherUploadData.opRecordList.length > 0) {
                            accVoucherUploadData.opRecordList.forEach(record => {
                                //	format 时间
                                record.opTime = this.timestampFormatter(record.opTime);
                            });
                        }

                        this.voucherUploadInfoForm = accVoucherUploadData;

                        //	查看记账凭证文件
                        this.$refs.accvoucher.getAccountVoucherDataById(this.voucher.vid);
                    });
                } else if(this.voucher.vftype == '2') {
                    this.getOriVoucherDetailDataById(this.voucher.vid).then(oriVoucherUploadData => {
                        if(oriVoucherUploadData.opRecordList && oriVoucherUploadData.opRecordList.length > 0) {
                            oriVoucherUploadData.opRecordList.forEach(record => {
                                record.opTime = this.timestampFormatter(record.opTime);
                            });
                        }

                        this.voucherUploadInfoForm = oriVoucherUploadData;
                        this.showVoucherFile(this.voucher.vid);	//	查看原始凭证文件
                    });
                }

                this.viewGroupDetailsDialogVisible = false;
                this.viewVolumeDetailsDialogVisible = false;
                this.viewVoucherDialogVisible = true;
            },
            viewGroupDetailsClickFun(groupId) {    //  查看分组明细
                //  加载组明细
                this.getGroupDetailData(groupId);
                this.viewGroupDetailsDialogVisible = true;
                this.viewVoucherDialogVisible = false;
                this.viewVolumeDetailsDialogVisible = false;

                //  对table重新布局，解决列错位问题
                this.$nextTick(() => {
                    this.$refs.groupDetailTable.doLayout();
                });
            },
            viewGroupVoucherDetailsClickFun(rowData) { //  分组 - 查看文件
                if(rowData.type != '0') {
                    this.voucher.vftype = "2";
                } else {
                    this.voucher.vftype = '1';
                }
                this.voucher.vid = rowData.id;
                this.viewVoucherDetailsClickFun();
            },
            viewVolumeDetailsClickFun(bookId) {   //  查看册明细
                this.getVolumeDetailDataById(bookId).then(volumeDetailData => {
                    this.volumeDetailForm.book = volumeDetailData.book;
                    //  分页查询册内组明细
                    this.getVolumeGroupDetailDataByBookId(bookId);
                    this.getBookConverInfo(bookId);
                });
                this.viewVoucherDialogVisible = false;
                this.viewGroupDetailsDialogVisible = false;
                this.viewVolumeDetailsDialogVisible = true;
            },
            async getAccVoucherDetailDataById(id) {	//	查看记账凭证详情（上传详情、操作记录）
                let accVoucherUploadData = [];
                await fetchPost('/archival/getAccountVoucherDetailListById', id).then(res => {
                    if(res.data.success) {
                        accVoucherUploadData = res.data.obj;
                    } else {
                        this.$message.error('加载记账凭证详情信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载记账凭证详情信息失败：' + error);
                });
                return accVoucherUploadData;
            },
            async getOriVoucherDetailDataById(id) {	//	查看原始凭证详情（上传详情、操作记录）
                let oriVoucherUploadData = [];
                await fetchPost('/archival/getOriginalVoucherDetailListById', id).then(res => {
                    if(res.data.success) {
                        oriVoucherUploadData = res.data.obj;
                    } else {
                        this.$message.error('加载原始凭证详情信息失败：' + res.data.message);	
                    }
                }, error => {
                    this.$message.error('加载原始凭证详情信息失败：' + error);
                });
                return oriVoucherUploadData;
            },
            downloadVoucherFileClickFun() {  //  查看凭证文件 - 下载
                if(this.voucher.vftype == '2') {
                    document.getElementById('downloadForm').submit();
                } else {
                    this.$message.error('记账凭证暂不支持下载！');
                }
            },
            downloadTempFileClickFun() {  //  查看凭证文件 - 下载
                if(this.voucher.vftype == '2') {
                    document.getElementById('downloadForm').submit();
                } else {
                    this.$message.error('记账凭证暂不支持下载！');
                }
            },
            batchDownloadVoucherFileClickFun() {
                this.$message.info('暂不支持批量下载！');
            },
            showVoucherFile(id) { //  显示原始凭证文件
				this.imagewidth=98
                let fileName = this.voucherUploadInfoForm.fileName;
                let fileType = fileName.substr(fileName.lastIndexOf('.') + 1);
                let image = document.getElementById("orivoucherImg");
                let iframe = document.getElementById('oriv_pdf_frame');
                let tokenParam = "&token=" + localStorage.getItem('token');
                let otherType = document.getElementById('otherTypeText');
                if(fileType.toLowerCase() == 'jpg' || fileType.toLowerCase() == 'png') {
                    image.style = "display:block";
                    iframe.style = "display:none";
                    otherType.style = "display:none";
                    image.src = this.baseURL + "/archival/getOriginalVoucherDataById?id=" + id + tokenParam;
                } else if(fileType.toLowerCase() == 'pdf') {
                    image.style = "display:none";
                    iframe.style = "display:block";
                    otherType.style = "display:none";
                    iframe.src = this.baseURL + "/archival/getOriginalVoucherDataById?id=" + id + tokenParam;
                } else if(fileType.toLowerCase() == 'ofd') {
                    image.style = "display:none";
                    iframe.style = "display:block";
                    otherType.style = "display:none";
                    iframe.src = this.ofdReaderPath + '/ofd/reader?file=' + this.baseURL + "/archival/getOriginalVoucherDataById?id=" + id + "%26token=" + localStorage.getItem("token");
                }  else if(fileType.toLowerCase() == 'zip') {
                    otherType.style = "display:block";
                    image.style = "display:none";
				    iframe.style = "display:none";
			    }  else {
                    this.$message.error('错误的文件类型，不支持查看！');
                    return;
                }
            },
			forchangwidth(e){
				if(e=="big"){
					this.imagewidth=this.imagewidth+10
				}
				if(e=="small"){
					this.imagewidth=this.imagewidth-10
				}
			},
            async getGroupDetailData(id) {  //  根据分组ID查询组内明细
                await fetchPost('/collation/group/getArchiveGroupDetailByGroupId', id).then(res => {
                    if(res.data.success) { 
                        this.groupDetailForm = res.data.obj;
                    } else {
                        this.$message.error('加载分组内明细信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载分组内明细信息失败：' + error);
                });
            },
            async getVolumeDetailDataById(id) {   //  根据册ID查询册信息
                let volumeDetailData = {};
                await fetchPost('/collation/book/getArchiveGroupListByBookId', id).then(res => {
                    if(res.data.success) {
                        volumeDetailData = res.data.obj;
                    } else {
                        this.$message.error('加载册内明细信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载册内明细信息失败：' + error);
                });
                return volumeDetailData;
            },
            async getVolumeGroupDetailDataByBookId(id) {    //  根据册ID查询册内组明细
                this.volumedetailpwm.search = { 'bookId': id };
                await fetchPost('/collation/book/getCollationGroupListByBookId', this.volumedetailpwm).then(res => {
                    this.volumeDetailForm.volumnDetailTableData = res.data.data;
                    this.volumedetailpwm.count = res.data.count;
                }, error => {
                    this.$message.error('加载册内组明细信息失败：' + error);
                });
            },
            async getBookConverInfo(id) {
                fetchPost('/collation/book/getCollationBookCoverInfo', id).then(res => {
                    if(res.data.success) {
                        this.manualVolumeCoverFormData = res.data.obj;
                    } else {
                         this.$message.error('加载册封面信息失败' +  + res.data.message);
                    }
                }, error => {
                     this.$message.error('加载册封面信息失败' + error);
                });
            },
        }
    }
</script>

<style scoped>
    .voucher-tag-title {
        font-size:14px;
        font-weight:bold;
        line-height: 25px;
        color: #66b1ff;
    }
    .voucher-tag-contmg {
        font-size: 12px;
        color:#909399;
    }
    .el-dialog {
        margin: 0 auto !important;
    }
    .el-dialog__header {
        padding: 0 !important;
    }
    .el-dialog__wrapper {
        display: flex ;
        align-items: center ;
    }
    .table {
		width: 100%;
		font-size: 14px;
    }
    /* 手工成册dialog 样式 */
    .mv-voucher-container {
        padding-bottom: 15px;
    }
    .mv-voucher-container .mv-voucher-header {
        text-align: center;
        padding-bottom: 15px;
    }
    .mv-voucher-container .mv-voucher-header span{
        font-size: 20px;
        font-weight: bold;
    }
    .mv-voucher-container .mv-voucher-body {
        border: 1px solid #DCDFE6;
    }
    .mv-voucher-container .mv-voucher-body .mv-voucher-row {
        border-bottom: 1px solid #DCDFE6;
        line-height: 45px;
    }
    .mv-voucher-container .mv-voucher-body .mv-voucher-title {
        text-align: center;
        border-right: 1px solid #DCDFE6;
    }
    .mv-voucher-body .mv-voucher-row .mv-voucher-content {
        text-align: right;
        padding-right: 15px;
        border-right: 1px solid #DCDFE6;
    }
    .mv-voucher-container .mv-voucher-body .mv-voucher-content-span {
        padding: 0px 15px;
        font-weight: bold;
    }
    .mv-voucher-container .mv-voucher-footer {
        padding-top: 15px;
    }
    .mv-voucher-container .mv-voucher-footer .mv-voucher-footer-span {
        padding: 0px 15px;
        font-weight: 500;
    }
</style>